<template>
    <div class="design-modal-button-container" v-on:click="showModal">
        <div class="design-modal-button-button">
            {{ locale("ripe_retail.designs.show_all") }}
        </div>
    </div>
</template>

<style scoped>
.design-modal-button-container {
    margin-bottom: 20px;
    text-align: right;
}

.design-modal-button-button {
    border-bottom: 1px solid #4d4d4d;
    color: #4d4d4d;
    cursor: pointer;
    display: inline-block;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
}
</style>

<script>
export const DesignModalButton = {
    name: "design-modal-button",
    methods: {
        showModal() {
            this.$bus.trigger("show_designs_modal");
        }
    }
};

export default DesignModalButton;
</script>
